import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=4ccf9154&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=4ccf9154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf9154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ccf9154')) {
      api.createRecord('4ccf9154', component.options)
    } else {
      api.reload('4ccf9154', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=4ccf9154&scoped=true&", function () {
      api.rerender('4ccf9154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lAPyEWY4MgMa/JS/comp/SearchFilterTokens.vue"
export default component.exports